import { render } from "./Administracao.vue?vue&type=template&id=06145d1c"
import script from "./Administracao.vue?vue&type=script&lang=js"
export * from "./Administracao.vue?vue&type=script&lang=js"

import "./Administracao.vue?vue&type=style&index=0&id=06145d1c&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__